import Columns from './tracts-column-names.json';
import TractData from './tracts-demographics.json';
import TractVotingData from './tracts-voting-demographics.json';
import ColumnsVoting from './tracts-column-names.json';


//This is for Tract data ONLY. See DemoArrayManager.js for legislative district (congress,st upper, st lower) data
export default class TractDemoArrayManager {
    constructor(config, type) {
        this.loading = true;
        this.columns = type === 'vap' ? ColumnsVoting.array : Columns.array;
        this.columnObj = type === 'vap' ? ColumnsVoting.obj : Columns.obj;
        this.config = config;
        this.loading = false;
        this.data = type === 'vap' ? TractVotingData : TractData;
    }

    ColToIdx(columnName) {
        return this.columns.indexOf(columnName);
    }

    IdxToCol(idx) {
        return this.columns[idx];
    }

    GetTractData(_geoid) {
        this.loading = true;
        if (this.data.length > 0) {
            return this.ArrayToObj(this.data.filter(d => d[0] === _geoid));
        }
        this.loading = false;
        return {}
    }

    GetTractArr(_geoid) {
        return this.data.filter(d => d[0] === _geoid);
    }

    ArrayToObj(arr) {
        let obj = {}
        this.columns.forEach((element, idx) => {
            if (arr && arr.length > 0) {
                obj[element] = arr[0][idx];
            }
        });
        this.loading = false;
        return obj;
    }
}